// extracted by mini-css-extract-plugin
export var image = "ImageRow-module--image--e8aab";